import React, { useState } from "react";

import axios from "axios";
import FunctionalRequestedProductsPage from "./FunctionalRequestedProducts"
import FunctionalGrantedProductsPage from "./FunctionalGrantedProducts"

import LoadingGif from "../../../assets/images/Spin_loader.gif"




function FunctionalHead({ setParentLoading, activeFunctionalHeadTab }) {

    

    return (
        <div >

          

                {/* CONTENTS */}

                <div
                     style={{
                    width: "100%",
                    minHeight: "100vh",
                    overflowY: "auto",
                    backgroundColor: "white",
                    padding: "10px",
                    boxSizing: "border-box"
                }}
                >

                    {/* REQUESTED PRODUCTS */}

                    {activeFunctionalHeadTab === "functionalheadrequestedproducts" &&
                        <div className="fade-container">
                            <FunctionalRequestedProductsPage setParentLoading={setParentLoading} />
                        </div>
                    }

                    {/* GRANTED PRODUCTS */}

                    {activeFunctionalHeadTab === "functionalheadgrantedproducts" &&
                        <div className="fade-container">

                            <FunctionalGrantedProductsPage setParentLoading={setParentLoading} />
                        </div>
                    }

                    {/* REPLACEMENT PRODUCTS */}

                    {activeFunctionalHeadTab === "functionalheadreplacementproducts" && <div className="fade-container">
                       <b>This page is under construction...</b>
                    </div>
                    }
                  


                </div>

            
        </div>
    )
}


export default FunctionalHead;